import { useState } from 'react';

import { hasValue } from '@core/utils/equality';

interface UseEntityDrawerReturn<T> {
  isOpen: boolean;
  entity: T | null;
  present(newEntity?: T): void;
  dismiss(): void;
}

export const useEntityDrawer = <T>(): UseEntityDrawerReturn<T> => {
  const [entity, setEntity] = useState<T | null>(null);
  const [isOpen, setOpen] = useState(false);

  const present = (newEntity?: T): void => {
    if (hasValue(newEntity)) setEntity(newEntity);
    setOpen(true);
  };

  const dismiss = (): void => {
    setEntity(null);
    setOpen(false);
  };

  return {
    isOpen,
    entity,
    present,
    dismiss,
  };
};
